<ng-container *ngIf="user$ | async; let user">
    <button (click)="startRecorder(user.canRecordUnlimited())" type="button" class="video-record" mat-menu-item>
        <mat-icon>videocam</mat-icon>
        <span i18n>Record video</span>
    </button>
</ng-container>
